/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types,jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import { sendRequest as createTaskExecSendRequest } from 'mt-react-common/modules/tasks/common/reducers/execCreateForm';
import { sendRequest as sendTaskToggleChosenMarkFormRequest } from 'mt-react-common/modules/tasks/common/reducers/taskToggleChosenMarkForm';
import { sendRequest as sendTaskToggleHideMarkFormRequest } from 'mt-react-common/modules/tasks/common/reducers/taskToggleHideMarkForm';

import RatingStars from 'components/Rating/RatingStars/index';
import PopUpLink from 'components/Common/GlobalPopUps/PopUpLink';
import CreateExecButton from './CreateExecButton';
import ManageBlock from './ManageBlock';

class RightSidebarViewTaskAsExec extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markHideButtonId: `markHideButton-${this.props.task.id}`,
      markChosenButtonId: `markChosenButton-${this.props.task.id}`
    };
  }

  componentWillUnmount() {
    // eslint-disable-next-line no-undef
    $(`#${this.state.markHideButtonId}`)
      .tooltip('fixTitle')
      .tooltip('hide');
    // eslint-disable-next-line no-undef
    $(`#${this.state.markChosenButtonId}`)
      .tooltip('fixTitle')
      .tooltip('hide');
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-sidebar-sticky">
          <div className="page-sidebar-sticky-wrp">
            <div
              aria-multiselectable="true"
              className="panel-group panel-group-side"
              id="panelGroupFilter"
              role="tablist"
            >
              <div className="panel panel-default border-b text-center">
                <div className="panel-body">
                  <div className="panel-title panel-title_xs">
                    <i aria-hidden="true" className="fa fa-check-square-o" />
                    {t('Заказчик')}
                  </div>
                  <img
                    alt=""
                    className="avatar avatar-responsive avatar_bordered"
                    src={this.props.task.ownerAvatarPath}
                  />
                  <h1 className="h5 text-overflow">
                    {this.props.task.ownerUserName}
                  </h1>
                  {this.props.task.ownerRating ? (
                    <div
                      className="label label-light label-success label_block text-overflow m-t-10"
                      data-toggle="tooltip"
                      data-container="body"
                      data-placement="top"
                      title={`${t('Рейтинг')}: ${
                        this.props.task.ownerRating.ratingStatusPoints
                      }/${this.props.task.ownerRating.ratingStatusPointsTo} (${
                        this.props.task.ownerRating.ratingStatusTitle
                      })`}
                    >
                      <RatingStars
                        rating={this.props.task.ownerRating.rating}
                      />{' '}
                      {this.props.task.ownerRating.ratingStatusTitle}
                    </div>
                  ) : null}
                </div>
              </div>
              <NavLink
                to={`/earn-money/task-view/${this.props.task.id}/desc`}
                activeClassName="active"
                className="list-group-item"
              >
                <span className="list-group-item-val text-overflow">
                  {t('Описание')}
                </span>
              </NavLink>
              <div className="list-group in">
                <NavLink
                  to={`/earn-money/task-view/${this.props.task.id}/reviews`}
                  activeClassName="active"
                  className="list-group-item list-group-item-head"
                >
                  <span className="badge">
                    {this.props.task.taskCommentsStat.total}
                  </span>
                  <span className="list-group-item-val text-overflow">
                    {t('Отзывы')}
                  </span>
                </NavLink>
                <div className="list-group-menu">
                  <NavLink
                    to={`/earn-money/task-view/${this.props.task.id}/reviews/likes`}
                    activeClassName="active"
                    className="list-group-item"
                  >
                    <span className="badge">
                      {this.props.task.taskCommentsStat.likes}
                    </span>
                    <span className="list-group-item-val text-overflow">
                      {t('Положительные')}
                    </span>
                  </NavLink>
                  <NavLink
                    to={`/earn-money/task-view/${this.props.task.id}/reviews/dislikes`}
                    activeClassName="active"
                    className="list-group-item"
                  >
                    <span className="badge">
                      {this.props.task.taskCommentsStat.dislikes}
                    </span>
                    <span className="list-group-item-val text-overflow">
                      {t('Отрицательные')}
                    </span>
                  </NavLink>
                  <NavLink
                    to={`/earn-money/task-view/${this.props.task.id}/reviews/neutral`}
                    activeClassName="active"
                    className="list-group-item"
                  >
                    <span className="badge">
                      {this.props.task.taskCommentsStat.neutral}
                    </span>
                    <span className="list-group-item-val text-overflow">
                      {t('Нейтральные')}
                    </span>
                  </NavLink>
                </div>
              </div>
              <NavLink
                to={`/earn-money/task-view/${this.props.task.id}/executions`}
                activeClassName="active"
                className="list-group-item"
              >
                <span className="list-group-item-val text-overflow">
                  {t('Мои выполнения')}
                </span>
              </NavLink>
            </div>
            <div className="panel-group panel-group-side">
              <div className="panel panel-default">
                <div className="panel-body">
                  <CreateExecButton
                    modalIndex={'sidebar'}
                    task={this.props.task}
                  />
                  <div className="btn-group btn-group-justified" role="group">
                    <a
                      id={this.state.markChosenButtonId}
                      className="btn btn-default"
                      data-container="body"
                      data-toggle="tooltip"
                      role="button"
                      tabIndex="0"
                      type="button"
                      data-original-title={`${this.props.task.markChosen.buttonMessage}`}
                      onClick={e => {
                        e.preventDefault();
                        this.props.taskToggleChosenMark();
                      }}
                    >
                      <i
                        className={`fa ${
                          this.props.task.markChosen.marked
                            ? 'fa-bookmark'
                            : 'fa-bookmark-o'
                        }`}
                      />
                    </a>
                    <a
                      id={this.state.markHideButtonId}
                      className="btn btn-default"
                      data-container="body"
                      data-toggle="tooltip"
                      role="button"
                      tabIndex="0"
                      type="button"
                      data-original-title={`${this.props.task.markHide.buttonMessage}`}
                      onClick={e => {
                        e.preventDefault();
                        this.props.taskToggleHideMark();
                      }}
                    >
                      <i
                        className={`fa ${
                          this.props.task.markHide.marked
                            ? 'fa-eye-slash'
                            : 'fa-eye'
                        }`}
                      />
                    </a>
                    <PopUpLink
                      hashName="taskComplaint"
                      hashParams={{ id: this.props.task.id }}
                      className="btn btn-default"
                      role="button"
                      type="button"
                    >
                      <div
                        className="full-width"
                        data-container="body"
                        data-placement="top"
                        data-toggle="tooltip"
                        title=""
                        data-original-title={t('Пожаловаться')}
                      >
                        <i className="fa fa-exclamation-triangle" />
                      </div>
                    </PopUpLink>
                  </div>
                </div>
              </div>
              <ManageBlock taskModel={this.props.task} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

RightSidebarViewTaskAsExec.contextTypes = {
  router: PropTypes.shape()
};

RightSidebarViewTaskAsExec.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    isFullReserved: PropTypes.bool.isRequired,
    markHide: PropTypes.shape({
      marked: PropTypes.bool,
      buttonMessage: PropTypes.string
    }).isRequired,
    markChosen: PropTypes.shape({
      marked: PropTypes.bool,
      buttonMessage: PropTypes.string
    }).isRequired,
    status: PropTypes.number.isRequired,
    ownerUserName: PropTypes.string.isRequired,
    ownerAvatarPath: PropTypes.string.isRequired,
    ownerRating: PropTypes.shape.isRequired,
    taskCommentsStat: PropTypes.shape.isRequired,
    executorExecutionInterval: PropTypes.number,
    myLastExec: PropTypes.shape({
      status: PropTypes.number
    })
  }).isRequired,

  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired
  }).isRequired,

  // CONNECT
  createTaskExecSendRequest: PropTypes.func.isRequired,
  taskToggleChosenMark: PropTypes.func.isRequired,
  taskToggleHideMark: PropTypes.func.isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = (dispatch, props) => ({
  createTaskExecSendRequest: () =>
    dispatch(
      createTaskExecSendRequest(
        'tasksModule.forms.execCreateForm',
        props.task.id
      )
    ),
  taskToggleChosenMark: () =>
    dispatch(
      sendTaskToggleChosenMarkFormRequest(
        'tasksModule.forms.taskToggleChosenMarkForm',
        props.task.id
      )
    ),
  taskToggleHideMark: () =>
    dispatch(
      sendTaskToggleHideMarkFormRequest(
        'tasksModule.forms.taskToggleHideMarkForm',
        props.task.id
      )
    )
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RightSidebarViewTaskAsExec)
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/TaskViewAsExecutor/RightSidebarViewTaskAsExec.js